import { FavoriteButtonWrapperContainer, addSavedOffer, showOnBoardingDelete } from '@cian/favorites-assign-widget';
import { useOffer, useTracking, useUser } from '../../hooks';
import * as React from 'react';
import { ControlWrapper } from '../../components/ControlWrapper';
import { deleteFromFavorites } from '../../services/deleteFromFavorites';
import { addToFavorites } from '../../services/addToFavorites';
import { useApplicationContext } from '../../context';
import {
  EAddFavoritesDealType,
  EAddFavoritesEntityType,
  EDeleteFavoritesDealType,
  EDeleteFavoritesEntityType,
} from '../../types/favorites';
import { FavoritesButton } from '../../components/FavoritesButton';
import { useEventCallback } from '@cian/react-utils';
import { useDispatch } from 'react-redux';
import type { UnknownAction } from 'redux';

export function FavoritesControlContainer() {
  const dispatch = useDispatch();
  const { id, isCianPartner, isFavorite: offerInFavorites, isNewbuilding, dealType, cianId } = useOffer();
  const { isAuthenticated } = useUser();
  const { onFavoritesAdd, onFavoritesRemove } = useTracking();
  const context = useApplicationContext();

  const [isFavorite, setFavorite] = React.useState(!!offerInFavorites);

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    // Новостройки или Жилая
    const entityType = isNewbuilding ? 'newbuilding' : 'offerResidental';

    if (isFavorite) {
      await deleteFromFavorites(context, {
        dealType: dealType as EDeleteFavoritesDealType,
        entityId: id,
        entityType: entityType as EDeleteFavoritesEntityType,
      });

      onFavoritesRemove();

      dispatch(showOnBoardingDelete() as unknown as UnknownAction);
    } else {
      const result = await addToFavorites(context, {
        dealType: dealType as EAddFavoritesDealType,
        entityId: id,
        entityType: entityType as EAddFavoritesEntityType,
      });

      if (!result) {
        return;
      }

      onFavoritesAdd();

      const userHasFolders = Boolean(result.hasFolders);
      const folder = result.folder;
      /* istanbul ignore next */
      const savedInFolders =
        folder && folder.name && folder.id
          ? [
              {
                id: folder.id,
                name: folder.name,
              },
            ]
          : null;

      dispatch(addSavedOffer({ offerIds: [id], savedInFolders, userHasFolders }) as unknown as UnknownAction);
    }

    setFavorite(!isFavorite);
  };

  const handleLogin = useEventCallback(() => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  });

  if (isCianPartner) {
    return null;
  }

  return (
    <ControlWrapper visible={true}>
      <FavoriteButtonWrapperContainer
        offerId={cianId}
        placement="bottom-end"
        isAuthenticated={isAuthenticated}
        onWaitForLogin={handleLogin}
      >
        <FavoritesButton isFavorite={isFavorite} onClick={handleClick} />
      </FavoriteButtonWrapperContainer>
    </ControlWrapper>
  );
}
